import find from 'lodash/find';
import noop from 'lodash/noop';
import { appendScript } from '../../../shared/utils/commonUtils';

export const getSessionData = (sessionItemName) => {
  const sessionData = sessionStorage.getItem(sessionItemName);
  return sessionData ? JSON.parse(sessionData) : {};
};

export const offerQualifyBuilder = ({
  offer, offerType, qualifyOffer, logTrack = noop,
}) => ({ quoteId, params }) => {
  return new Promise((resolve) => {
    qualifyOffer({
      offerType,
      params,
    }).unwrap().then(({ widgetToken }) => {
      offer.CommerceObserver.emit('qualify', {
        params: { dynamicToken: widgetToken, quoteId },
        callback: (qualifyCallback = {}) => {
          const { status, response } = qualifyCallback;
          resolve({
            ...qualifyCallback,
            status: status === 'success',
            widgetToken,
          });
          if (status !== 'success') {
            logTrack?.({
              params: {
                message: `qualify ${offerType} failed: ${JSON.stringify(response)}`,
              },
            });
          }
        },
      });
    }).catch(() => {
      resolve({ status: false });
    });
  });
};

export const offerSubmit = ({
  submitToken, quoteId, widgetNameSpace, logTrack = noop, offerType,
}) => {
  const { widgetAPIServerHost } = getSessionData(`${widgetNameSpace}-initOfferParams`);
  submitToken && window.COMMERCEWidget && window.COMMERCEWidget.submitOffer({
    widgetAPIServerHost,
    quoteId,
    params: { dynamicToken: submitToken },
    callback: ({ status, response }) => {
      if (status !== 'success') {
        logTrack?.({
          params: {
            message: `submit ${offerType} failed: ${JSON.stringify(response)}`,
          },
        });
      }
    },
  });
};

export const aaCrossSubmit = (submitToken, widgetNameSpace, logTrack) => {
  const { quoteId } = getSessionData(`${widgetNameSpace}-checkoutAACross`);
  offerSubmit({
    widgetNameSpace,
    submitToken,
    quoteId,
    logTrack,
    offerType: 'aa-cross',
  });
};

export const activeRefundSubmit = (submitToken, widgetNameSpace, logTrack) => {
  const { quoteId } = getSessionData(`${widgetNameSpace}-checkoutActiveRefund`);
  offerSubmit({
    widgetNameSpace,
    submitToken,
    quoteId,
    logTrack,
    offerType: 'active-refund',
  });
};

export const convertOfferData = ({
  offerInitInfoResponse,
  bankRedirectSuccess,
  widgetNameSpace,
}) => {
  if (bankRedirectSuccess) {
    const { widgetAPIServerHost, widgetSDKUrl } = getSessionData(`${widgetNameSpace}-initOfferParams`);
    const { activeRefundToken: aRToken } = getSessionData(`${widgetNameSpace}-checkoutActiveRefund`);
    const { AACrossToken: aaToken } = getSessionData(`${widgetNameSpace}-checkoutAACross`);
    const mgzDatas = getSessionData(`${widgetNameSpace}-checkoutMagazine`);
    return {
      offerInitData: {
        widgetAPIServerHost,
        widgetSDKUrl,
      },
      activeRefundToken: aRToken,
      AACrossToken: aaToken,
      magazineDatas: mgzDatas,
    };
  }
  const { offerData, ...offerInitData } = offerInitInfoResponse || {};
  const activeRefundToken = find(offerData, { type: 'ACTIVE_REFUND' })?.widgetToken;
  const AACrossToken = find(offerData, { type: 'ACTIVE_ADVANTAGE_CROSS_SELL' })?.widgetToken;
  const magazineDatas = find(offerData, { type: 'SYNAPSE_MAGAZINE_OFFER_TYPE' });
  return {
    offerInitData,
    activeRefundToken,
    AACrossToken,
    magazineDatas,
  };
};

const appendOfferScript = (url, resolve) => {
  if (!url) {
    resolve(false);
    return;
  }
  const onReadyCallback = () => {
    window.COMMERCEWidget && window.COMMERCEWidget.onReady((ACW) => {
      window.COMMERCEWidget.offerRenderer = ACW;
      resolve(true);
    });
  };
  const onErrorCallback = () => {
    resolve(false);
  };
  appendScript(url, onReadyCallback, true, undefined, onErrorCallback);
};

export const initOffer = ({
  widgetNameSpace,
  offerInitInfoResponse,
  bankRedirectSuccess,
}) => {
  return new Promise((resolve) => {
    const { offerInitData } = convertOfferData({
      offerInitInfoResponse,
      bankRedirectSuccess,
      widgetNameSpace,
    });
    const { widgetSDKUrl } = offerInitData;
    appendOfferScript(widgetSDKUrl, resolve);
  });
};
